import { QueryType } from '@/app/types/types'
import { apiClient } from '..'

const getOneJobApplicationRequest = (id: number) => {
    return apiClient().get(`/api/jobApplications/${id}`)
}

const updateJobApplicationRequest = (id: number, data: QueryType) => {
    return apiClient().put(`/api/jobApplications/${id}`, data)
}

const updateJobApplicationStatusRequest = (jobApplicationId: number, data: { status?: string; customFields?: Record<string, any> }) => {
    return apiClient().patch('/api/jobApplications/status', {
        jobApplicationId,
        ...data,
    })
}

const getAllJobApplicationsRequest = (query: QueryType) => {
    return apiClient().get('/api/jobApplications', { params: query })
}

const deleteJobApplicationRequest = (id: number) => {
    return apiClient().delete(`/api/jobApplications/${id}`)
}

export {
    getOneJobApplicationRequest,
    updateJobApplicationRequest,
    updateJobApplicationStatusRequest,
    getAllJobApplicationsRequest,
    deleteJobApplicationRequest,
}
